import formatMoney from '../formatMoney';

const updatePrice = ({ priceEl, compareAtPriceEl, badgeEl, price, compareAtPrice, badgeTemplate }) => {
  if (!priceEl) return;

  if (badgeEl) {
    if (compareAtPrice > price) {
      const salePercentage = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      badgeEl.textContent = badgeTemplate.replace('{{ percentage }}', salePercentage);
      badgeEl.classList.remove('hidden!');
    } else {
      badgeEl.textContent = '';
      badgeEl.classList.add('hidden!');
    }
  }

  if (compareAtPriceEl) {
    if (compareAtPrice > price) {
      compareAtPriceEl.textContent = formatMoney(compareAtPrice);
      compareAtPriceEl.classList.remove('hidden');
    } else {
      compareAtPriceEl.textContent = '';
      compareAtPriceEl.classList.add('hidden');
    }
  }
  priceEl.textContent = formatMoney(price);
};

export default updatePrice;
